export const ECHARTS_GRID = {
  top: "25px",
  right: "15px",
  bottom: "45px",
  left: "45px"
}
